import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, FileText, GitCompareArrows, Tags } from "lucide-react";
import { api } from "../../lib/api";

const cards = [
  { key: "software", label: "Software Reviews", icon: Boxes, to: "/admin/software" },
  { key: "articles", label: "Guides & Articles", icon: FileText, to: "/admin/articles" },
  { key: "comparisons", label: "Comparisons", icon: GitCompareArrows, to: "/admin/comparisons" },
  { key: "categories", label: "Categories", icon: Tags, to: "/admin/categories" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl font-bold text-slate-900">Dashboard</h1>
      <p className="text-sm text-slate-500 mt-1">Manage everything visitors see on the public portal.</p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`dashboard-card-${c.key}`}
            className="bg-white rounded-lg border border-border p-5 hover:border-sky-400 transition-colors duration-200">
            <c.icon className="w-5 h-5 text-sky-500 mb-3" aria-hidden="true" />
            <p className="font-heading font-bold text-3xl text-slate-900">{stats ? stats[c.key]?.total : "–"}</p>
            <p className="text-sm text-slate-500 mt-1">{c.label}</p>
            {stats && c.key !== "categories" && (
              <p className="text-xs text-slate-400 mt-1">{stats[c.key]?.published} published</p>
            )}
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-white rounded-lg border border-border p-6">
        <h2 className="font-heading font-bold text-slate-900 text-sm mb-3">Quick tips</h2>
        <ul className="text-sm text-slate-600 space-y-2 list-disc pl-5">
          <li>Content marked <span className="font-semibold">draft</span> is hidden from the public portal and sitemap.</li>
          <li>Every item has SEO fields (title, meta description, slug) — fill them for best rankings.</li>
          <li>Software features power the public filters and the Integration Matrix automatically.</li>
        </ul>
      </div>
    </div>
  );
}
